import React from 'react'

export function EFCheckMark() {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.87371 8.66782C0.690251 8.46143 0.374215 8.44284 0.167823 8.6263C-0.0385679 8.80975 -0.0571583 9.12579 0.126301 9.33218L4.1263 13.8322C4.31743 14.0472 4.65013 14.057 4.85356 13.8536L15.3536 3.35355C15.5488 3.15829 15.5488 2.84171 15.3536 2.64645C15.1583 2.45118 14.8417 2.45118 14.6465 2.64645L4.52141 12.7715L0.87371 8.66782Z'
        fill='#13C11A'
      />
    </svg>
  )
}
